__turbopack_context__.v({
  "link": "managePromptsLink-module-scss-module__8SQe4a__link",
});
